import { container } from '@/container';

export const ConfirmTabAwayMixin = {
    methods: {
        /**
         * This method is called from TabbedModalMixin when changing the currently active tab in a modal.
         * If the hasUnsavedChanges method returns true it prompts the user if they are okay with
         * losing their changes.
         *
         * @returns {Promise<boolean>}
         */
        async beforeTabAway() {
            if (this.hasUnsavedChanges()) {
                return container.dialogService
                    .confirm(
                        'UNSAVED_TAB_CHANGES',
                        {
                            cancelLabel: 'GO_BACK',
                            cancelColor: 'default',
                            okLabel: 'DISCARD_CHANGES',
                            okColor: 'danger',
                        }
                    )
                    .then((result) => {
                        if (result === true) {
                            return true;
                        }

                        throw new Error('Current tab has unsaved changes.');
                    });
            }

            return true;
        },

        hasUnsavedChanges() {
            return false;
        },
    },
};
